<template>
    <div class="total-price">
        <span class="total-price__text" v-text="translations.header"></span>
        <p class="total-price__price">
            <transition name="price-transition">
                <span class="total-price__price__text" v-if="totalPrice">
                    {{ (showFrom) ? translations.from : '' }}
                    <span v-price="totalPrice"></span>
                    {{ currency }}
                </span>
            </transition>
        </p>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            totalPrice: {type: Number, default: 0},
            currency: {type: String, default: 'DKK'},
            showFrom: {type: Boolean, default: true}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.TOTAL_PRICE                
            }
        }
    }
</script>